import { Stack } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import React from 'react';
import { ChatBoxTab } from '../Admin/CommunicationPage/components/ChatBoxTab';

function ChatScreen() {
  return (
    <Stack width={'100%'} px={{ xs: 1, sm: 0 }}>
      <Helmet>
        <title>Surrey Bailiffs - Leads</title>
      </Helmet>
      <Stack sx={{ display: 'flex' }} maxWidth={'100%'}>
        <ChatBoxTab isMobile />
      </Stack>
    </Stack>
  );
}

export default ChatScreen;
